/* eslint-disable @typescript-eslint/naming-convention */
export const BREAKPOINTS = {
  mobileSmall: "320px",
  mobile: "375px",
  mobileLarge: "425px",
  tabletSmall: "600px",
  tablet: "768px",
  tabletLarge: "980px",
  desktopSmall: "1024px",
  desktop: "1280px",
  desktopLarge: "1440px",
  desktopXLarge: "1920px",
  desktopXXLarge: "2200px",
};
